import _ from 'lodash';
import React, { useCallback, useState } from 'react';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';
import SelectTag from 'react-scale/corp/components/UI/SelectTag/SelectTag';
import { SelectOption } from 'react-scale/corp/components/UI/Select';
import { Button } from '@scale/scaleui';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';

interface WorkerTagsListBuilderProps {
  name: string;
  required?: boolean;
  existingValue?: string[];
  updateProperty: (arg: string[]) => void;
  typeBuilderMap: TypeBuilderMapType;
  allowMultiple?: boolean;
}

const WorkerTagsListBuilder: React.FC<WorkerTagsListBuilderProps> = ({
  existingValue = [],
  typeBuilderMap,
  updateProperty,
}) => {
  const [newTag, setNewTag] = useState<SelectOption | undefined>();

  const addTag = useCallback(() => {
    if (!_.isUndefined(newTag)) {
      const updatedProperty = _.clone(existingValue);
      updatedProperty.push(newTag.value.trim());
      updateProperty(updatedProperty);
      setNewTag(undefined);
    }
  }, [existingValue, newTag, updateProperty]);

  return (
    <div className="scaleui scaleui-tailwind scale-theme">
      <div className="prose text-sm mb-4">Tags to compare against the Worker's</div>
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={existingValue}
        setElements={updateProperty}
        getKey={(tag: string) => tag}
        getTitle={(tag: string) => tag}
        restrictFields={true}
        getSchema={() => ({})}
      />

      <div className="flex mt-4">
        <SelectTag placeholder="Select a Tag" value={newTag} onChange={setNewTag} />
        <Button className="ml-4 my-auto min-w-max" onClick={addTag} size="sm">
          Add Tag
        </Button>
      </div>
    </div>
  );
};

export default WorkerTagsListBuilder;
